module.exports = __webpack_public_path__ + "img/rent.0760c308.svg";